import LiningCodeSearch from "@/components/LiningCodeSearch";

/**
 * Inner Facing Piping row — a searchable lining-fabric input that records the
 * customer-appointed lining used for the inner facing piping. The factory's
 * parent code (C-0853, "Customer appointed inner facing piping") is shown as a
 * fixed badge next to the label; the user's typed/picked value is the chosen
 * lining fabric code from the 158-code catalog.
 *
 * Stores the chosen code in `inner_facing_piping` on the styling state.
 */
export default function InnerFacingPipingRow({ value, onChange, testId }) {
  return (
    <div className="mt-3 pt-3 border-t border-white/5" data-testid={testId}>
      <div className="flex items-center gap-2 mb-2">
        <p className="text-[10px] uppercase tracking-wider text-slate-400">
          Inner Facing Piping
        </p>
        <code className="text-[10px] text-amber-400/80 font-mono">C-0853</code>
        <span className="text-[10px] text-slate-500 italic">
          (Customer appointed inner facing piping)
        </span>
      </div>
      <div className="max-w-xs">
        <LiningCodeSearch
          value={value || ""}
          onChange={onChange}
          placeholder="FLLDL031 / lining book code"
          testId={`${testId}-input`}
        />
      </div>
    </div>
  );
}
